import { MatrixProduct } from '@/models/matrix-product.model';

export class MatrixOrder {
  public selected: boolean;
  public total: number;
  public matrixProducts: MatrixProduct[];
  public date?: Date;
  public orderId?: string;
}
